import React from "react";
import { Snackbar, Box, SnackbarOrigin } from "@mui/material";
import ByzMuiTypography from "../inputs/ByzMuiTypography";
import { ByzMuiIconButton } from "../buttons/ByzMuiIconButton";

interface ByzMuiSnackBarProps extends React.ComponentProps<typeof Snackbar> {
  open: boolean;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  title: string;
  message: string;
  type?: "success" | "error";
  anchorOrigin?: SnackbarOrigin;
  autoHideDuration?: number;
}

const ByzMuiSnackBar: React.FC<ByzMuiSnackBarProps> = (props) => {
  const {
    open,
    onClose,
    title,
    message,
    type = "success",
    anchorOrigin = { vertical: "bottom", horizontal: "right" },
    autoHideDuration = 3000,
    ...restProps
  } = props;

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    onClose(event, reason);
  };

  const toastColors = {
    success: { background: "#E6FAF5", border: "#00CC99", icon: "/assets/icons/toast/success.svg" },
    error: { background: "#FDEEEE", border: "#EB5757", icon: "/assets/icons/toast/error.svg" },
  };

  const currentColors = toastColors[type as keyof typeof toastColors] || toastColors.success;
  //
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      {...restProps}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: currentColors.background,
          borderRadius: "0.5vh",
          padding: "1rem",
          borderLeft: `1vh solid ${currentColors.border}`,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "50%",
            width: "2.25rem",
            height: "2.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {<img src={currentColors.icon} alt={type} style={{ width: "19px", height: "19px" }} />}
        </Box>

        <Box display={"flex"} sx={{ marginLeft: "1rem" }}>
          <Box display={"flex"} flexDirection={"column"} alignItems={"start"} columnGap={"0.5rem"}>
            <ByzMuiTypography
              sx={{
                fontWeight: "400",
                fontSize: "16.5px",
                display: "flex",
                marginLeft: "0px",
              }}
            >
              {title}
            </ByzMuiTypography>
            <ByzMuiTypography
              sx={{
                fontWeight: "400",
                fontSize: "14px",
                display: "flex",
                marginLeft: "0px",
              }}
            >
              {message}
            </ByzMuiTypography>
          </Box>
        </Box>

        <ByzMuiIconButton size="small" onClick={onClose}>
          <img src={"/assets/icons/toast/close.svg"} alt="close" style={{ width: "2rem", height: "2rem" }} />
        </ByzMuiIconButton>

      </Box>
    </Snackbar>
  );
};

export default ByzMuiSnackBar;
